import Showdown from 'showdown';

export const mdConverter = new Showdown.Converter({
  tables: true,
  literalMidWordUnderscores: true,
});
